import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { WithSnackbarProps, withSnackbar, SnackbarKey} from "notistack";
import { removeSnackbar } from "../../Shared/Redux/Actions/notificationActions";
import { NotificationInfo, SharedApplicationData } from "../../Shared/sharedTypes"

let displayed: SnackbarKey[] = [];

const mapState = function ({ notifications }: SharedApplicationData) {
    return {
        notifications,
    };
};
const mapDispatch = {
    removeSnackbar,
};

const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>;
type PropTypes = PropsFromRedux & WithSnackbarProps & {};

const Notifier = ({ notifications, enqueueSnackbar, closeSnackbar, removeSnackbar }: PropTypes) => {
    const storeDisplayed = (id: SnackbarKey) => {
        displayed = [...displayed, id];
    };

    const removeDisplayed = (id: SnackbarKey) => {
        displayed = [...displayed.filter((key) => id !== key)];
    };

    React.useEffect(() => {
        notifications.forEach(({ key, message, options = {}, dismissed = false }: NotificationInfo) => {
            if (key) {
                if (dismissed) {
                    // dismiss snackbar using notistack
                    closeSnackbar(key);
                    return;
                }

                // do nothing if snackbar is already displayed
                if (displayed.includes(key)) return;

                // display snackbar using notistack
                enqueueSnackbar(message, {
                    key,
                    ...options,
                    onClose: (event, reason, myKey) => {
                        if (options.onClose) {
                            options.onClose(event, reason, myKey);
                        }
                    },
                    onExited: (event, myKey: SnackbarKey) => {
                        // remove this snackbar from redux store
                        removeSnackbar(myKey);
                        removeDisplayed(myKey);
                    },
                    autoHideDuration: options?.autoHideDuration
                });

                // keep track of snackbars that we've displayed
                storeDisplayed(key);
            }
        });
    }, [notifications, closeSnackbar, enqueueSnackbar]);

    return null;
};

export default connector(withSnackbar(Notifier));
